import { registerPlugin } from '@capacitor/core';
const SentryCapacitor = registerPlugin('SentryCapacitor');
export { SentryCapacitor };
//# sourceMappingURL=plugin.js.map